// Lib
import * as Immutable from 'immutable';

// Types
import { VisibleConnectionStatus } from './visibleConnectionStatusTypes';

// The current status that the app is in - whether the reconnecting spinner, or "trying to reconnect" spinner shows
export const selectVisibleConnectionStatus = (state: Immutable.Map<string, any>): VisibleConnectionStatus =>
    state.getIn(['app', 'socketConnection', 'visibleConnectionStatus']);
